import React from 'react';
import PropTypes from 'prop-types';

import { useDictionary } from 'bdvp-common/src/hooks/config';

import {
    Wrapper,
    Title,
} from './Header.styles';

const Header = ({
    clearAllButton,
    isFreeTextSearchEnabled,
}) => {

    const dictionary = useDictionary();

    return (
        <Wrapper>
            <Title>
                {isFreeTextSearchEnabled
                    ? dictionary.filters ?? 'Filters'
                    : dictionary.video_search ?? 'Video Search'
                }
            </Title>
            {clearAllButton}
        </Wrapper>
    );

};

Header.propTypes = {
    isFreeTextSearchEnabled: PropTypes.bool,
    clearAllButton: PropTypes.element,
};

Header.defaultProps = {
    isFreeTextSearchEnabled: false,
    clearAllButton: undefined,
};

export default Header;
